import useSWR from 'swr';
import { AccountOwner } from '../api';
import { getAccountOwnerByCustomer } from '../api';

export const useAccountOwner = (customerId?: string) => {
  const key = customerId ? `/account-owner/${customerId}` : null;
  const {
    data: accountOwner,
    isLoading,
    isValidating,
  } = useSWR<AccountOwner | undefined>(key, async () => getAccountOwnerByCustomer(customerId));

  return {
    accountOwner: accountOwner?.name ? accountOwner : undefined,
    leadStoreId: accountOwner?.storeId,
    accountOwnerIsLoading: isLoading && isValidating,
  };
};
